import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AppContext } from '../window';
import { useTranslation } from '../i18n';

interface PricesModalProps {
  show: boolean;
  onHide: () => void;
}

interface CMSContent {
  content: string;
  language: string;
}

const PricesModal: React.FC<PricesModalProps> = ({ show, onHide }) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const [content, setContent] = useState<CMSContent | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && !content) {
      fetchContent();
    }
  }, [show, content]);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const response = await fetch('/site/page?view=prices&json=1');
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      }
    } catch (error) {
      console.error(t('about.error_fetching_prices_content'), error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('about.prices')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('general.loading')}</span>
            </div>
          </div>
        ) : (
          content && (
            <div dangerouslySetInnerHTML={{ __html: content.content }} />
          )
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('general.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PricesModal;